export { default as LookupListTemplate } from './LookupListTemplate';
export { default as LookupEditTemplate } from './LookupEditTemplate';
export { default as LookupSelectTemplate } from './LookupSelectTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/lookup/pages/index.js